ko.bindingHandlers.slide = {
  update: function(element, valueAccessor) {
    var afterAnimation, duration, isCurrentlyVisible, shouldShow, value;
    value = ko.unwrap(valueAccessor()) || false;
    shouldShow = false;
    duration = 300;
    isCurrentlyVisible = $(element).css('display') !== 'none';
    afterAnimation = valueAccessor().afterAnimation;
    if (typeof value === 'object') {
      if (value.visible != null) {
        shouldShow = ko.unwrap(value.visible);
      } else {
        throw new Error('You need to have a visible value... ');
      }
      duration = value.duration || duration;
    } else {
      shouldShow = value;
    }
    if (shouldShow && !isCurrentlyVisible) {
      $(element).stop(true, true).css('display', 'none').slideDown(duration, function() {
        if (typeof afterAnimation === 'function') {
          afterAnimation.call();
        }
      });
    } else if (!shouldShow && isCurrentlyVisible) {
      $(element).stop(true, true).slideUp(duration, function() {
        if (typeof afterAnimation === 'function') {
          afterAnimation.call();
        }
      });
    }
  }
};
